import React from "react";

const API_BASE =
  (import.meta?.env?.VITE_API_BASE) ||
  (process.env?.REACT_APP_API_BASE) ||
  "https://api.sorokokorki.com.pl";

export default function ThankYouPayment() {
  const [info, setInfo] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setError("Brak identyfikatora płatności w adresie URL.");
      setLoading(false);
      return;
    }
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/api/orders/${sessionId}/summary`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        setInfo(data);
      } catch (e) {
        setError("Nie udało się pobrać informacji o zamówieniu.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <section style={{ display:"flex", justifyContent:"center", padding:"40px 16px" }}>
      <div style={{ maxWidth:680, width:"100%", background:"#fff", border:"1px solid #e5e7eb", borderRadius:16, padding:24, boxShadow:"0 2px 8px rgba(0,0,0,.04)" }}>
        <style>{`
          .title { font-size:1.5rem; font-weight:700; margin:0 0 8px; }
          .lead { color:#374151; margin:0 0 14px; }
          .muted { color:#6b7280; }
          .btn { display:inline-flex; align-items:center; justify-content:center; padding:12px 16px; border-radius:12px; border:0; background:#2563eb; color:#fff; font-weight:600; font-size:1rem; cursor:pointer; text-decoration:none; }
          .row { display:flex; align-items:flex-start; gap:12px; }
          .check { width:36px; height:36px; border-radius:999px; background:#22c55e; color:#fff; display:inline-flex; align-items:center; justify-content:center; font-weight:700; }
          .box { background:#f8fafc; border:1px solid #e5e7eb; border-radius:12px; padding:12px; margin:12px 0; }
        `}</style>

        <div className="row">
          <span className="check">✓</span>
          <h1 className="title">Dziękujemy za opłatę!</h1>
        </div>
        <p className="lead">Twoje zlecenie zostało przyjęte do realizacji.</p>

        {loading && <p className="muted">Ładowanie szczegółów zamówienia…</p>}
        {error && <p className="muted">{error}</p>}

        {info && (
          <div className="box">
            <p style={{ margin:0 }}>
              Rozwiązania/wyjaśnienia prześlemy na adres e‑mail podany przy zamówieniu: <strong>{info.email || "(brak danych)"}</strong>.
            </p>
            <p className="muted" style={{ margin:"8px 0 0" }}>
              W razie pytań możesz odpowiedzieć na wiadomość zwrotną lub napisać na kontakt@sorokokorki.com.pl.
            </p>
          </div>
        )}

        <div style={{ marginTop:16 }}>
          <a className="btn" href="/">Przejdź na stronę główną</a>
        </div>
      </div>
    </section>
  );
}
